import React from "react";
import AddFinancieraForm from "./AddFinancieraForm";

const AddFinanciera = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Nueva Financiera"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddFinancieraForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddFinanciera;
